<template>
  <el-form class="rule-form">
    <BasicModule v-bind:formObj="form" ref="basic" @setObj="setRuleObj"></BasicModule>

    <BoxOfficeModule v-bind:formObj="form" ref="boxOffice"></BoxOfficeModule>

    <div class="form-module">
      <p class="module-title">{{ $locale("rules.generalPricing") }}</p>
      <TicketItem
        v-bind:formObj="form.ticketRule.generalTicket"
        v-bind:groupList="groupList"
        v-bind:ticketTypeList="ticketTypeList"
        v-bind:couponTypeList="couponTypeList"
        v-bind:addTicketItem="false"
        v-bind:addIcon="false"
        v-bind:removeIcon="false"
        v-bind:componentIndex="0"
        v-bind:discountList="discountList"
        v-bind:formName="form.name"
        ref="general"
        key="general"
        type="general"
        @itemHandle="ticketItemHandle"
        v-bind:couponList="comCouponList"
        @setList="setCouponList"
      ></TicketItem>
    </div>

    <div class="form-module">
      <div class="title">
        <p class="module-title">{{ $locale("rules.otherTicketTypeSettings") }}</p>
        <div class="addItem" @click="ticketItemHandle('add')">{{$locale("rules.addTicket")}}</div>
      </div>
      <template v-for="(otherObj, i) in form.ticketRule.otherTicket">
        <TicketItem
          v-bind:isCL="true"
          v-bind:formObj="otherObj"
          v-bind:groupList="groupList"
          v-bind:ticketTypeList="ticketTypeList"
          v-bind:couponTypeList="couponTypeList"
          v-bind:addTicketItem="true"
          v-bind:addIcon="i == form.ticketRule.otherTicket.length - 1"
          v-bind:removeIcon="true"
          v-bind:componentIndex="i"
          v-bind:discountList="discountList"
          v-bind:formName="form.name"
          :key="'other' + i"
          :ref="'other' + i"
          type="other"
          :index="i"
          @itemHandle="ticketItemHandle"
          v-bind:couponList="comCouponList"
          @setList="setCouponList"
        ></TicketItem>
      </template>
    </div>

    <CommonCouponModule v-bind:formObj="form" ref="commonCoupon"></CommonCouponModule>
    <el-row>
      <el-col :xs="8" :sm="10" :md="12" :lg="12">
        <el-form-item :label="$locale('rules.notAvailableMovieCoupons_multi')" style="width:100%;">
          <RemoteSelectV2
            type="coupon"
            useType="all"
            :list="comCouponList"
            v-model="form.ticketRule.unCouponTypeIds"
            :formValue.sync="form.ticketRule.unCouponTypeIds"
            :fields="['id', 'name']"
            @selectAll="arr => form.ticketRule.unCouponTypeIds = arr"
            :isSelectAllFunc="true"
            @change="handleChange"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <CouponTypeModule v-bind:formObj="form" ref="couponType" v-bind:advanceCouponTypeList="advanceCouponTypeList"></CouponTypeModule>

    <div class="form-module">
      <p class="module-title">{{ $locale("rules.versionSurcharge") }}</p>
      <div class="key-block">
        <div class="block-r">
          <PriceRuleItem
            v-for="(priceRule, i) in versionList"
            :key="'version' + i"
            :ref="'version' + i"
            v-bind:formObj="formatVersionRuleObj(priceRule)"
            v-bind:itemTitle="{ id: priceRule.id, name: versionList[i].name }"
            v-bind:isLabel="i == 0"
            v-bind:titleLabel="i == 0 ? $locale('global.versions') : ''"
            v-bind:couponTypeList="couponTypeList"
            v-bind:componentType="'version'"
            v-bind:versionList="versionList"
            v-bind:versionIndex="i"
            v-bind:formName="form.name"
            v-bind:couponList="comCouponList"
            @setList="setCouponList"
          ></PriceRuleItem>
        </div>
      </div>
    </div>

    <div class="form-module">
      <p class="module-title">{{ $locale("rules.seatPricingRules") }}</p>
      <div class="key-block">
        <div class="block-r">
          <PriceRuleItem
            v-for="(priceRule, i) in form.ticketRule.seatPriceRule"
            :key="'seat' + i"
            :ref="'seat' + i"
            v-bind:formObj="priceRule"
            v-bind:itemTitle="{ id: priceRule.id, name: seatList[i].name }"
            v-bind:isLabel="i == 0"
            v-bind:titleLabel="i == 0 ? ' ' : ''"
            v-bind:couponTypeList="couponTypeList"
            v-bind:componentType="'seat'"
            v-bind:versionList="versionList"
            v-bind:versionIndex="0"
            v-bind:couponList="comCouponList"
            @setList="setCouponList"
          ></PriceRuleItem>
        </div>
      </div>
    </div>

    <TimeModule
      v-bind:formObj="form"
      ref="time"
    ></TimeModule>
  </el-form>
</template>

<script>
import BasicModule from "./BasicModule.vue";
import BoxOfficeModule from "./BoxOfficeModule.vue";
import TicketItem from "./TicketItem.vue";
import CommonCouponModule from "./CommonCouponModule.vue";
import CouponTypeModule from "./CouponTypeModule.vue";
import PriceRuleItem from "./PriceRuleItem.vue";
import TimeModule from "./TimeModule.vue";
import RemoteSelectV2 from '@/components/common/RemoteSelect-v2';
import { createFormObj } from "@/assets/js/ruleTemplate.js";
import { getDiscountRuleTemplateList } from "@/helpers/service/api/discountRuleTemplate";
import RuleTest from "@/utils/simpleRule.js";
import "@/assets/style/rulesTemplate.less";
import tranfResData from "@/utils/tranfResData";
import { getCouponTypeListForSelect } from "@/helpers/service/api/coupon";

export default {
  name: "ruleTemplateForm",
  inject: [ "couponList" ],
  data() {
    return {
      ruleForm: {},
      form: {
        ticketRule: {
          generalTicket: {},
          otherTicket: [ {} ],
          versionPriceRule: [],
          seatPriceRule: [],
          posStartSale: {},
          posEndSale: {},
          webStartSale: {},
          webEndSale: {},
          scStartSale: {},
          scEndSale: {},
          standingmax: 0,
          advanced: {},
          customizeMsg: [ {
            deviceType: "",
            message: "",
          } ],
          wheelchairDisplayPos: true,
          wheelchairDisplaySelfCashier: true,
          wheelchairDisplayWeb: true,
        },
      },
      discountList: [],
      rule: {
        name: {
          required: this.$locale("form.plsEnterYourName"),
        },
      },
      ticketRule: {
        name: {
          required: this.$locale("form.plsEnterYourName"),
        },
        price: {
          required: this.$locale("form.plsEnterPrice"),
        },
        sort: {
          required: this.$locale("form.plsEnterSorting"),
        },
        // ticketTypeId: {
        //   required: this.$locale("rules.plsSelectTicketCategory"),
        // },
      },
      versionRule: {
        price: {
          required: this.$locale("rules.plsEnterAdditionalCharge"),
        },
      },
      timeRule: {
        seatMaxPos: {
          required: `${this.$locale("rules.maxNumOfPurchases")}（${this.$locale("global.POS")}）${this.$locale("form.plsEnter")}`,
        },
        seatMaxSelfCashier: {
          required: `${this.$locale("rules.maxNumOfPurchases")}（${this.$locale("global.selfCheckout")}）${this.$locale("form.plsEnter")}`,
        },
        seatMaxWeb: {
          required: `${this.$locale("rules.maxNumOfPurchases")}（${this.$locale("global.online")}）${this.$locale("form.plsEnter")}`,
        },
        webPreSaleSeatMax: {
          required: `${this.$locale("rules.maxNumOfPurchases")}（${this.$locale("dailyDetail.preSale")}）${this.$locale("form.plsEnter")}`,
        },
      },
      seatList: [
        {
          id: "vip",
          name: this.$locale("theatre.seat.vip"),
        },
        {
          id: "special",
          name: this.$locale("theatre.seat.special"),
        },

        {
          id: "general",
          name: this.$locale("theatre.seat.general"),
        },
        {
          id: "wheelchair",
          name: this.$locale("theatre.seat.wheelchair"),
        },
        {
          id: "lovers",
          name: this.$locale("theatre.seat.loversSeat"),
        },
        {
          id: "posCounter",
          name: this.$locale("theatre.seat.windowSeat"),
        }
      ],
      comCouponList: []
    };
  },
  methods: {
    handleChange(value) {
      if (value.includes("all")) {
        this.form.ticketRule.unCouponTypeIds = ['all'];
      }
    },
    formatVersionRuleObj(priceRule) {
      let obj = this.form.ticketRule.versionPriceRule.find(item => item.relationId === priceRule.id);
      if (!obj) {
        return {
          advanceCouponType: "possible",
          advanceCouponTypeIds: null,
          boxOffice: true,
          commonCoupon: "possible",
          invitationCouponType: "possible",
          price: 0,
          relationId: priceRule.id,
          couponCode: null,
          seatsStatus: null,
          unCouponTypeIds: [],
        };
      }
      return obj;
    },
    setCouponList(arr) {
      this.comCouponList = this.$_.uniqBy(arr, "id");
    },
    setRuleObj(obj) {
      this.form = obj;
      if (!obj.ticketRule.customizeMsg || obj.ticketRule.customizeMsg.length === 0) {
        this.form.ticketRule.customizeMsg = [ {
          deviceType: "",
          message: ""
        } ];
      }
      if (!obj.ticketRule.webPreSaleRule) {
        this.form.ticketRule.webPreSaleRule = [ {
          membershipRankId: "",
          timeAmount: null,
          timeUnit: "minute",
        } ];
      }
      if (!obj.ticketRule.posPreSaleRule) {
        this.form.ticketRule.posPreSaleRule = [ {
          membershipRankId: "",
          timeAmount: null,
          timeUnit: "minute",
        } ];
      }
      if (!obj.ticketRule.scPreSaleRule) {
        this.form.ticketRule.scPreSaleRule = [ {
          membershipRankId: "",
          timeAmount: null,
          timeUnit: "minute",
        } ];
      }
    },
    saveForm() {
      const that = this;
      let form = {};
      let basicObj = RuleTest(that.rule, {
        ...that.$refs.basic.form,
      });

      let generalObj = tranfResData(RuleTest(that.ticketRule, {
        ...that.$refs.general.form,
      }));
      let otherTicket = [];
      let testOtherTicket = {};
      let versionPriceRule = [];
      let testVersionPriceRule = true;
      let seatPriceRule = [];
      let testSeatPriceRule = true;
      let timeObj = tranfResData({ ...that.$refs.time.form });
      let testTimeObj = RuleTest(that.timeRule, {
        seatMaxPos: timeObj.seatMaxPos,
        seatMaxSelfCashier: timeObj.seatMaxSelfCashier,
        seatMaxWeb: timeObj.seatMaxWeb,
        webPreSaleSeatMax: timeObj.webPreSaleSeatMax,
      });
      for (let i = 0; i < that.form.ticketRule.otherTicket.length; i++) {
        testOtherTicket = RuleTest(that.ticketRule, that.$refs["other" + i][0].form).success;

        if (testOtherTicket) {
          otherTicket.push(tranfResData(that.$refs["other" + i][0].form));
        }
      }

      for (let i = 0; i < that.versionList.length; i++) {
        versionPriceRule.push({ ...that.$refs["version" + i][0].form });

        if (testVersionPriceRule) {
          testVersionPriceRule = RuleTest(that.versionRule, that.$refs["version" + i][0].form).success;
        }
      }

      for (let i = 0; i < that.form.ticketRule.seatPriceRule.length; i++) {
        seatPriceRule.push({ ...that.$refs["seat" + i][0].form });

        if (testSeatPriceRule) {
          testSeatPriceRule = RuleTest(that.versionRule, that.$refs["seat" + i][0].form).success;
        }
      }

      if (!basicObj.success) {
        that.$alert(basicObj.message, {
          showClose: false,
        });

        return;
      }

      if (!generalObj.success) {
        that.$alert(generalObj.message, {
          showClose: false,
        });

        return;
      }

      if (!testVersionPriceRule) {
        that.$alert(that.versionRule.price.required, {
          showClose: false,
        });

        return;
      }

      if (!testSeatPriceRule) {
        that.$alert(that.versionRule.price.required, {
          showClose: false,
        });

        return;
      }

      if (!testTimeObj.success) {
        that.$alert(testTimeObj.message, {
          showClose: false,
        });

        return;
      }

      // comboTicket validation
      console.log("general...", that.$refs.general.form);
      // generalTicket
      const { comboItems: general_comboItems } = that.$refs.general.form;
      const isIDError = general_comboItems.some(item => item.type && !item.id);
      const isPriceError = general_comboItems.some(item => item.id && !item.price);
      if (isIDError) {
        that.$alert("一般券種 " + this.$locale("rules.sellTogether") + this.$locale("form.plsSelect"), {
          showClose: false,
          lockScroll: false,
          onClose: () => {
            document.getElementById("general").scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
        return;
      }
      if (isPriceError) {
        that.$alert("一般券種 " + this.$locale("rules.shopItemsAmount") + this.$locale("form.plsSelect"), {
          showClose: false,
          lockScroll: false,
          onClose: () => {
            document.getElementById("general").scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
        return;
      }
      // otherTicket
      const { otherTicket: _otherTicket } = that.form.ticketRule;
      if (_otherTicket) {
        for (let i = 0; i < _otherTicket.length; i++) {
          const { comboItems: other_comboItems } = that.$refs["other" + i][0].form;
          const isOtherIDError = other_comboItems.some(item => item.type && !item.id);
          const isOtherPriceError = other_comboItems.some(item => item.id && !item.price);
          if (isOtherIDError) {
            that.$alert("その他券種 " + this.$locale("rules.sellTogether") + this.$locale("form.plsSelect"), {
              showClose: false,
              lockScroll: false,
              onClose: () => {
                document.getElementById("other" + i).scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            });
            return;
          }
          if (isOtherPriceError) {
            that.$alert("その他券種 " + this.$locale("rules.shopItemsAmount") + this.$locale("form.plsSelect"), {
              showClose: false,
              lockScroll: false,
              onClose: () => {
                document.getElementById("other" + i).scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            });
            return;
          }
        }
      }


      if (generalObj.data.warningMsg[generalObj.data.warningMsg.length - 1].deviceType == "" && generalObj.data.warningMsg[generalObj.data.warningMsg.length - 1].message == "") {
        generalObj.data.warningMsg.length = generalObj.data.warningMsg.length - 1;
      }
      const timeObjLast = timeObj.customizeMsg[timeObj.customizeMsg.length - 1];
      if (!timeObjLast.deviceType && !timeObjLast.message) {
        timeObj.customizeMsg.length = timeObj.customizeMsg.length - 1;
      }
      for (let i = 0; i < otherTicket.length; i++) {
        if (otherTicket[i].warningMsg[otherTicket[i].warningMsg.length - 1].deviceType == "" && otherTicket[i].warningMsg[otherTicket[i].warningMsg.length - 1].message == "") {
          otherTicket[i].warningMsg.length = otherTicket[i].warningMsg.length - 1;
        }
      }
      form = {
        ...basicObj.data,
        ticketRule: {
          ...that.form.ticketRule,
          ...that.$refs.boxOffice.form,
          generalTicket: {
            ...generalObj.data,
            comboBoxOfficePrice: that.$refs.general.computedPrice,
          },
          otherTicket: otherTicket.map((item, idx) => ({
            ...item,
            comboBoxOfficePrice: that.$refs["other" + idx][0].computedPrice
          })),
          versionPriceRule: versionPriceRule,
          seatPriceRule: seatPriceRule,
          ...that.$refs.commonCoupon.form,
          ...that.$refs.couponType.form,
          ...timeObj,
        },
      };

      form.ticketRule.versionPriceRule.map(item => {
        if (item.seatsStatus instanceof Array) {
          if (item.seatsStatus.indexOf("null") >= 0) {
            item.seatsStatus = null;
          }
        }
        if (item.advanceCouponTypeIds instanceof Array) {
          if (item.advanceCouponTypeIds.indexOf("null") >= 0) {
            item.advanceCouponTypeIds = null;
          }
        }
      });

      form.ticketRule.seatPriceRule.map(item => {
        if (item.seatsStatus instanceof Array) {
          if (item.seatsStatus.indexOf("null") >= 0) {
            item.seatsStatus = null;
          }
        }
        if (item.advanceCouponTypeIds instanceof Array) {
          if (item.advanceCouponTypeIds.indexOf("null") >= 0) {
            item.advanceCouponTypeIds = null;
          }
        }
      });

      return form;
    },
    ticketItemHandle(type, index) {
      let form = tranfResData(this.form);
      let originalForm = createFormObj();
      let newOtherTicket = [];

      let versionPriceRule = [];
      let seatPriceRule = [];
      let timeObj = tranfResData({ ...this.$refs.time.form });

      for (let i = 0; i < this.form.ticketRule.versionPriceRule.length; i++) {
        versionPriceRule.push({ ...this.$refs["version" + i][0].form });
      }

      for (let i = 0; i < this.form.ticketRule.seatPriceRule.length; i++) {
        seatPriceRule.push({ ...this.$refs["seat" + i][0].form });
      }

      form = {
        ...form,
        name: this.$refs.basic.form.name,
        ticketRule: {
          ...form.ticketRule,
          ...this.$refs.boxOffice.form,
          generalTicket: {
            ...this.$refs.general.form,
            otherTicket: [],
            versionPriceRule: versionPriceRule,
            seatPriceRule: seatPriceRule,
            ...this.$refs.commonCoupon.form,
            ...this.$refs.couponType.form,
            ...timeObj,
          },
        },
      };

      for (let i = 0; i < form.ticketRule.otherTicket.length; i++) {
        newOtherTicket.push(tranfResData(this.$refs["other" + i][0].form));
      }

      form.ticketRule.otherTicket = newOtherTicket;

      if (type == "add") {
        if (newOtherTicket.length === 0) {
          form.ticketRule.otherTicket.push(tranfResData({ ...originalForm.ticketRule.generalTicket, default: false }));
        } else {
          let lastTicketItem = tranfResData(newOtherTicket[newOtherTicket.length - 1]);
          let testLastItem = RuleTest(this.ticketRule, lastTicketItem);
          if (testLastItem.success) {
            form.ticketRule.otherTicket.push(tranfResData({ ...originalForm.ticketRule.generalTicket, default: false }));
          }
        }
      } else {
        form.ticketRule.otherTicket.splice(index, 1);
      }

      this.form = form;
    },
  },
  created() {
    getDiscountRuleTemplateList({
      cinemaId: window.localStorage.getItem("cinemaId"),
      page: 0,
      pageSize: 9999,
    }).then(res => {
      this.discountList = res.data.data;
    });
  },
  mounted() {
    let form = { ...createFormObj(), ticketRule: { ...createFormObj().ticketRule, wheelchairDisplayPos: true, wheelchairDisplaySelfCashier: true, wheelchairDisplayWeb: true } };

    // form.ticketRule.otherTicket.push(tranfResData({ ...form.ticketRule.generalTicket, default: false, }));

    this.seatList.forEach(obj => {
      form.ticketRule.seatPriceRule.push({
        advanceCouponType: "possible",
        boxOffice: true,
        commonCoupon: "possible",
        invitationCouponType: "possible",
        price: 0,
        relationId: obj.id,
        unCouponTypeIds: [],
        // seatCouponCode: [],
        couponCode: "",
      });
    });

    this.form = form;
    /**
     * schedule dailog, part of RULE TEMPLATE handling
     */
    if (this.forSchedule) {
      let { generalTicket, otherTicket, versionPriceRule, seatPriceRule } = this.formObj.ticketRule;
      let genIds = generalTicket.couponIds;
      let otherIds = [];
      otherTicket.forEach(item => {
        otherIds.push(...item.couponIds);
      });
      let versionIds = [];
      versionPriceRule.forEach(item => {
        versionIds.push(...(item.unCouponTypeIds || []));
      });
      let seatIds = [];
      seatPriceRule.forEach(item => {
        seatIds.push(...(item.unCouponTypeIds || []));
      });
      // if (genIds.length > 0 || otherIds.length > 0 || versionIds.length > 0 || seatIds.length > 0) {
      //   getCouponTypeListForSelect({
      //     cinemaId: window.localStorage.getItem("cinemaId"),
      //     ids: [...genIds, ...otherIds, ...versionIds, ...seatIds],
      //     field: ["id", "name"],
      //     page: 0,
      //     pageSize: 9999
      //   }).then(res => {
      //     this.comCouponList = this.$_.uniqBy(res.data.data.concat(this.injectCouponList), "id");
      //   });
      // }
      this.form = { ...this.form, ...this.formObj };
      this.form.name = this.form.ticketRuleName;
      const _form = tranfResData(this.form);
      const _seatPriceRuleData = tranfResData(_form.ticketRule.seatPriceRule);

      this.seatList.forEach(_seat => {
        const _target = _seatPriceRuleData.find(_rule => _seat.id === _rule.relationId);
        if (!_target) {
          _form.ticketRule.seatPriceRule.push({
            advanceCouponType: "possible",
            boxOffice: true,
            commonCoupon: "possible",
            invitationCouponType: "possible",
            price: 0,
            relationId: _seat.id,
            unCouponTypeIds: [],
          });
        }
      });

      if (_form.ticketRule.otherTicket.length === 0) {
        // _form.ticketRule.otherTicket.push(tranfResData({ ...form.ticketRule.generalTicket, default: false, }));
      }
      this.form = _form;
    }
  },
  computed: {
    injectCouponList() {
      return this.couponList();
    },
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
    groupList: {
      type: Array,
      default: () => [],
    },
    ticketTypeList: {
      type: Array,
      default: () => [],
    },
    couponTypeList: {
      type: Array,
      default: () => [],
    },
    advanceCouponTypeList: {
      type: Array,
      default: () => [],
    },
    versionList: {
      type: Array,
      default: () => [],
    },
    forSchedule: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    versionList() {
      let form = tranfResData({ ...this.form, ...this.formObj });
      let newVersionPriceRule = [];
      const _seatPriceRuleData = tranfResData(form.ticketRule.seatPriceRule);

      this.seatList.forEach(_seat => {
        const _target = _seatPriceRuleData.find(_rule => _seat.id === _rule.relationId);
        if (!_target) {
          form.ticketRule.seatPriceRule.push({
            advanceCouponType: "possible",
            boxOffice: true,
            commonCoupon: "possible",
            invitationCouponType: "possible",
            price: 0,
            relationId: _seat.id,
            unCouponTypeIds: [],
          });
        }
      });

      for (let i = 0; i < this.versionList.length; i++) {
        newVersionPriceRule.push({
          advanceCouponType: "possible",
          boxOffice: true,
          commonCoupon: "possible",
          invitationCouponType: "possible",
          price: 0,
          relationId: this.versionList[i].id,
          unCouponTypeIds: [],
        });

        for (let j = 0; j < form.ticketRule.versionPriceRule.length; j++) {
          if (this.versionList[i].id == form.ticketRule.versionPriceRule[j].relationId) {
            newVersionPriceRule[i] = { ...newVersionPriceRule[i], ...form.ticketRule.versionPriceRule[j] };
            break;
          }
        }
      }

      form.ticketRule.versionPriceRule = newVersionPriceRule;

      // this.form = form;
      this.$set(this, "form", form);
    },
    formObj: {
      handler(nv) {
        if (nv) {
          this.form.ticketRule.wheelchairDisplayWeb = nv.ticketRule.wheelchairDisplayWeb;
          this.form.ticketRule.wheelchairDisplayPos = nv.ticketRule.wheelchairDisplayPos;
          this.form.ticketRule.wheelchairDisplaySelfCashier = nv.ticketRule.wheelchairDisplaySelfCashier;
        }
      },
      deep: true
    },
    injectCouponList(val) {
      // if (val.length > 0 && this.$route.path.indexOf("create") > -1) {
      //   this.comCouponList = val
      // }
      this.comCouponList = val;
    }
  },
  components: {
    BasicModule,
    BoxOfficeModule,
    TicketItem,
    CommonCouponModule,
    CouponTypeModule,
    PriceRuleItem,
    TimeModule,
    RemoteSelectV2,
  },
};
</script>
